export default "__VITE_ASSET__DHxVA2GX__"